<template>
  <section v-if="name === 'showcasebg'" class="section">
    <div class="section-header with-border">
      设置
    </div>
    <div class="section-body">
      <el-form label-width="100px">
        <el-form-item label="标题">
          <el-input v-model="base.title"></el-input>
        </el-form-item>
        <el-form-item label="副标题">
          <el-input v-model="base.subtitle"></el-input>
        </el-form-item>
        <el-form-item label="组件间距">
          <el-switch
            v-model="base.padded"
            active-color="#27cc6a"
            inactive-color="#efefef">
          </el-switch>
        </el-form-item>

        <el-form-item label="展示图第1个背景图第2个背景图文字">
          <div class="setting-item slider " v-for="(item, index) in data">
            <div class="setting-remove" @click="removeItem(index)"><i class="iconfont icon-trash-alt"></i></div>
            <img v-if="item.imgUrl" :src="wximageurl + item.imgUrl" class="banner-uploader" @click="handleImgChange(index)"/>
            <div class="banner-uploader" v-else @click="handleImgChange(index)">
              <div class="content-center">
                <i class="iconfont icon-camera"></i><br>
                上传图片
              </div>
            </div>
            <div class="uploader-setting">
              <div class="goods-select" @click="handleGoodsChange(index)">
                <div class="link-content" v-if="item.id">
                  <template v-if="item.linkPage === 'goods'">商品：</template>
                  <template v-if="item.linkPage === 'category'">分类：</template>
                  <template v-if="item.linkPage === 'article'">文章：</template>
                  <template v-if="item.linkPage === 'planting'">软文：</template>
                  <template v-if="item.linkPage === 'link'">页面：</template>
                  <template v-if="item.linkPage === 'marketing'">营销：</template>
                  {{item.title}}
                </div>
                <div v-else class="content-center"><i class="iconfont icon-link" @click="handleGoodsChange(index)"></i>设置路径</div>
              </div>
            </div>
          </div>
          <el-button :disabled="data.length >= 20" type="default" class="iconfont icon-plus-circle banner-button-uploader" @click="addItem"> 添加项目</el-button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      res: {
        type: Object,
        default: {}
      }
    },
    watch: {
      res: {
        deep: true,
        handler (value) {
          if (value) {
            this.setData(value)
          }
        }
      }
    },
    data () {
      return {
        name: '',
        base: {},
        config: {},
        data: []
      }
    },
    methods: {
      setData(val) {
        this.name = val.name
        this.base = val.base
        this.config = val.config
        this.data = val.data
      },

        addItem () {
            if (!this.data) {
                this.data = []
            }
            let item = {
                imgUrl: '',
                linkPage: '',
                content: '',
                id: ''
            }
            if(this.data.length > 20) {
                this.$message({
                    message: '轮播图最多添加20个图片',
                    type: 'error',
                    duration: 5 * 1000
                })
            } else {
                this.data.push(item)
            }
        },
      removeItem (index) {
         this.data.splice(index, 1)
      },
      handleImgChange (index) {
        this.$emit('bindImgs', index)
      },
      handleGoodsChange (index) {
        this.$emit('bindLinks', index)
      }
    },
    mounted() {
      this.setData(this.res)
    }
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// showcasebg.vue?18bd594c